import React from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import Logo from "@/components/logo/Logo";
import { useMerchantSlug } from "@/utils/hooks/useMerchantSlug";
import Button from "../ui/Button";

const OrderConfirmation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("order_id") || "N/A";
  const merchantSlug = useMerchantSlug();

  const handleClose = () => {
    navigate(`${merchantSlug}`);
  };

  return (
    <div className="flex flex-col items-center min-h-screen bg-white p-4">
      <div className="w-full max-w-md bg-white">
        <Link className="absolute top-10 right-10" to={`${merchantSlug}`}>
          <svg
            className="w-8 h-8 text-gray-700"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 6L18 18M6 18L18 6"
            />
          </svg>
        </Link>
        <div className="mx-8 mt-32">
          <h1 className="text-2xl font-bold mb-8">Enjoy your order</h1>

          <p className="mb-4 text-lg font-semibold">
            Thanks for ordering with Redbird
            <br />
            Your order id is: <span className="text-red-600">{orderId}</span>
            <br />
            We have sent a confirmation text to your phone number.
          </p>
          <div className="flex justify-center mb-20">
            <div className="flex gap-2 mb-4 items-end">
              <p className="-m-1">Powered by</p>
              <Logo className="" size="h-16" />
            </div>
          </div>
          <Button
            variant="primary"
            text="Close"
            className="w-full h-12"
            onClick={handleClose}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
